const skills = {
  en: [
    {
      name: "python",
      percent: "90",
      category: "Programing Language",
    },
    {
      name: "pytorch",
      percent: "70",
      category: "Platform",
    },
    {
      name: "keras",
      percent: "70",
      category: "Platform",
    },
    {
      name: "Java Script",
      percent: "80",
      category: "Programing Language",
    },
    {
      name: "React",
      percent: "60",
      category: "Frontend",
    },
    {
      name: "power bi",
      percent: "80",
      category: "Platform",
    },
    {
      name: "business intelligence",
      percent: "80",
      category: "Topics",
    },
    {
      name: "Artificial intelligence",
      percent: "60",
      category: "Topics",
    },
    {
      name: "HTML CSS",
      percent: "80",
      category: "Frontend",
    },
    {
      name: "Office",
      percent: "70",
      category: "Platform",
    },
    {
      name: "English",
      percent: "80",
      category: "Science",
    },
    {
      name: "web application",
      percent: "70",
      category: "Science",
    },
    {
      name: "responcive Design",
      percent: "80",
      category: "Frontend",
    },
    {
      name: "Sql server",
      percent: "90",
      category: "Platform",
    },
    {
      name: "Wordpress",
      percent: "60",
      category: "Platform",
    },
    {
      name: "Figma",
      percent: "60",
      category: "Platform",
    },
    {
      name: "help desk",
      percent: "80",
      category: "Science",
    },
    {
      name: "Agile system",
      percent: "60",
      category: "Science",
    },
    {
      name: "version control",
      percent: "50",
      category: "Science",
    },
    {
      name: "Github",
      percent: "70",
      category: "Platform",
    },
  ],

  fa: [
    {
      name: "پایتون",
      percent: "90",
      category: "Programing Language",
    },
    {
      name: "پایتورچ",
      percent: "60",
      category: "Platform",
    },
    {
      name: "کراس",
      percent: "70",
      category: "Platform",
    },
    {
      name: "جاوا اسکریپت",
      percent: "80",
      category: "Programing Language",
    },
    {
      name: "ری‌اکت",
      percent: "70",
      category: "Frontend",
    },
    {
      name: "POWER BI",
      percent: "80",
      category: "Platform",
    },
    {
      name: "هوش تجاری",
      percent: "80",
      category: "Science",
    },
    {
      name: "هوش مصنوعی",
      percent: "70",
      category: "Science",
    },
    {
      name: "HTML CSS",
      percent: "85",
      category: "Frontend",
    },
    {
      name: "ماکروسافت آفیس",
      percent: "60",
      category: "Platform",
    },
    {
      name: "زبان انگلیسی",
      percent: "80",
      category: "Science",
    },
    {
      name: "وب اپلیکیشن",
      percent: "70",
      category: "Science",
    },
    {
      name: "طراحی واکنش‌گرا",
      percent: "75",
      category: "Frontend",
    },
    {
      name: "Sql server",
      percent: "90",
      category: "Platform",
    },
    {
      name: "وردپرس Wordpress ",
      percent: "60",
      category: "Platform",
    },
    {
      name: "فیگما Figma",
      percent: "60",
      category: "Platform",
    },
    {
      name: "help desk",
      percent: "85",
      category: "Science",
    },
    {
      name: "Agile system",
      percent: "60",
      category: "Science",
    },
    {
      name: "ورژن کنترل",
      percent: "70",
      category: "Science",
    },
    {
      name: "گیت‌هاب",
      percent: "60",
      category: "Platform",
    },
  ],
};

export default skills;
